import moment from 'moment';
import { Release } from "../types/service"

export function buildClassNames(baseClass = '', classNames = '') {
  return [baseClass]
    .concat(classNames)
    .join(' ')
    .trim();
}

export function formatDate(build: Release) {
  const newDate = moment(build.build_time);
  return `${newDate.format("MMM DD")} at ${newDate.format("h:mma")}`
}
export function handleLocalStorage(serviceName: string) {
  const serviceExistsInStorage = isServiceInStorage(serviceName || '');

  if (serviceExistsInStorage && serviceName) {
    return removeFromLocalStorage(serviceName);
  }

  const favorites = getFromLocalStorage();
  favorites.push(serviceName);
  return setToLocalStorage(favorites);
}

export function getFromLocalStorage(): string[] {
  const stringFavorites = localStorage.getItem('chronicle-service-favorites');

  if (stringFavorites) {
    return JSON.parse(stringFavorites);
  }

  return []
}

export function setToLocalStorage(favorites: string[]) {
  localStorage.setItem('chronicle-service-favorites', JSON.stringify(favorites));
}

export function isServiceInStorage(serviceName: string) {
  const favorites = getFromLocalStorage();

  if (favorites.length) {
    return favorites.includes(serviceName);
  };

  return false;
}

export function removeFromLocalStorage(serviceName: string) {
  const favorites = getFromLocalStorage();
  
  if (favorites.length) {
    const filteredFavorites = favorites.filter(favorite => favorite !== serviceName);
    setToLocalStorage(filteredFavorites);
  }
}
